/* AQ — La pastille du tronc commun, v4.0, 2026-09-08. Chargé partout par
   snippets/aq-fonts. Décision de Félix du 2026-09-08 (la dernière) : une
   pastille du tronc commun est un LIEN vers la page de cette valeur, rien
   d'autre. Plus de tiroir (v2), plus de palette (v3). Tant que la page de
   valeur n'existe pas, le href du snippet aq-tc-pastilles mène à la
   collection filtrée par la facette ; quand la page existe, le snippet
   pointe dessus. Ce script ne fait plus que mesurer le geste. La palette
   garde son API window.aqPalette.open pour d'autres usages. */
(function(){
  'use strict';
  document.addEventListener('click', function(e){
    var a=e.target.closest('[data-aq-tc]');
    if(!a || !window.aqMesure) return;
    window.aqMesure('pastille', {vocabulaire: a.getAttribute('data-aq-tc-voc')||'', valeur: a.getAttribute('data-aq-tc-value')||a.textContent.trim()});
  });
})();
